import React from 'react';
import {components, type ControlProps} from 'react-select';

import {Button, Flex, Text} from '@spothero/ui';
import FormLabel from 'common/form-elements/FormLabel';

type CustomControlProps = ControlProps & {
    selectProps: {
        inputId?: string;
        label: string;
        onClearAll?: () => void;
        subLabel?: string;
    };
};

const MultiselectControl = (props: CustomControlProps) => {
    const {label, onClearAll, subLabel, inputId} = props.selectProps;
    const labelText = label.toString();
    const subLabelText = subLabel?.toString();

    const handleClearAll = () => {
        if (onClearAll) {
            onClearAll();
        }
    };

    return (
        <>
            <Flex justify="space-between" marginBottom={1.5}>
                {(labelText || subLabelText) && (
                    <FormLabel
                        id={`${inputId}-label`}
                        htmlFor={inputId}
                        marginBottom={0}
                    >
                        {labelText}
                        {subLabelText && (
                            <>
                                <br />
                                <Text as="span" fontSize="xs" color="gray.dark">
                                    {subLabelText}
                                </Text>
                            </>
                        )}
                    </FormLabel>
                )}
                {onClearAll && (
                    <Button
                        onClick={handleClearAll}
                        variant="tertiary"
                        fontSize="xs"
                        zIndex="layer1"
                        alignSelf="flex-end"
                        aria-label={`Clear all ${labelText}`}
                    >
                        Clear
                    </Button>
                )}
            </Flex>
            <components.Control {...props} />
        </>
    );
};

export default MultiselectControl;
